import { Validators } from '@angular/forms';
import {
  TypedFormArray,
  TypedFormControl,
  TypedFormGroup,
} from '@principle-theorem/ng-shared';
import {
  AccProviderTypeCode,
  IAccReferral,
} from '@principle-theorem/principle-core/interfaces';
import { hasRequiredError } from './form-group-helpers';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export interface IAccReferralManagementForm {
  includeReferrals: boolean | undefined;
  referrals: IAccReferral[];
}

export class AccReferralManagementFormGroup extends TypedFormGroup<IAccReferralManagementForm> {
  constructor() {
    super({
      includeReferrals: new TypedFormControl<boolean | undefined>(undefined),
      referrals: new TypedFormArray<IAccReferral>([]),
    });

    this.controls.includeReferrals.valueChanges
      .pipe(takeUntilDestroyed())
      .subscribe((value) =>
        value
          ? this.referralFormArray.push(new AccReferralFormGroup())
          : this.referralFormArray.clear()
      );
  }

  patch(data: IAccReferralManagementForm): void {
    this.controls.includeReferrals.patchValue(data.includeReferrals);

    this.referralFormArray.clear();
    data.referrals.forEach((referral) => {
      this.referralFormArray.push(new AccReferralFormGroup(referral));
    });
  }

  addReferralForm(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.referralFormArray.push(new AccReferralFormGroup());
  }

  removeReferralForm(event: Event, index: number): void {
    event.preventDefault();
    event.stopPropagation();
    this.referralFormArray.removeAt(index);
  }

  // Getters
  get referralFormArray(): TypedFormArray<IAccReferral> {
    return this.controls.referrals as TypedFormArray<IAccReferral>;
  }

  get referralControls(): AccReferralFormGroup[] {
    return this.referralFormArray.controls as AccReferralFormGroup[];
  }
}

export class AccReferralFormGroup extends TypedFormGroup<IAccReferral> {
  constructor(referral?: Partial<IAccReferral>) {
    super({
      providerTypeCode: new TypedFormControl<AccProviderTypeCode>(
        undefined,
        Validators.required
      ),
      referralReason: new TypedFormControl<string>(undefined),
    });

    if (referral) {
      this.patchValue(referral);
    }
  }

  get providerTypeCodeRequiredError(): boolean {
    return hasRequiredError(this.controls.providerTypeCode);
  }
}
